@if (showField$ | async) {
  <div class="wrapper">
    @if (field.placeholder) {
      <label id="radio-group-label">{{ field.placeholder }}</label>
    }
    <mat-slider>
      <input matSliderThumb
        [formControl]="$any(field.control)"
        [step]="field.attrs.step"
        [min]="field.attrs.min"
        [max]="field.attrs.max">
    </mat-slider>
    @if (hasDanger()) {
      <mat-hint [ngStyle]="{'color': 'red'}" fxFlexAlign="start">{{ errorText() }}</mat-hint>
    }
    @if (field.help && !hasDanger()) {
      <mat-hint fxFlexAlign="start">{{ field.help | translate }}</mat-hint>
    }
  </div>
}

